<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">Create {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboards</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">Create</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Tambah {{ module }}</h4>
            <form class="form-sample" @submit.prevent="save()">
              <!-- <p class="card-description">Personal info</p> -->
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(item, index) in fields"
                  :key="index"
                >
                  <div class="form-group">
                    <label>{{ item[alias_table + "_f_label"] }}</label>
                    <small
                      v-if="item[alias_table + '_f_validation'] != ''"
                      class="pull-right text-danger"
                      >*{{ item[alias_table + "_f_validation"] }}</small
                    >
                    <component
                      :is="item[alias_table + '_f_input_type'] + '_form'"
                      :name="item[alias_table + '_f_name']"
                      :validation="item[alias_table + '_f_validation']"
                      :content="item['content']"
                      :dropdown_name="item[alias_table + '_f_options']"
                      @post="bindingData"
                    ></component>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Roles</label>
                    <small class="pull-right text-danger">*required</small>
                    <v-select
                      label="name"
                      :reduce="options => options.value"
                      :options="options_usr_admin"
                      v-model="post.usr_admin"
                    >
                      <template #search="{attributes, events}" v-if="post.usr_admin !== 0 && post.usr_admin !== 1">
                        <input class="vs__search" :required="!post.usr_admin" v-bind="attributes" v-on="events" />
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Password</label>
                    <small class="pull-right text-danger">*required</small>
                    <input
                      type="password"
                      v-model="post.usr_password"
                      :class="
                        error.usr_password != null
                          ? 'is-invalid form-control form-control-sm'
                          : 'form-control form-control-sm'
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="error.usr_password != null"
                    >
                      {{ error.usr_password.join() }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Konfirmasi Password</label>
                    <small class="pull-right text-danger">*required</small>
                    <input
                      type="password"
                      v-model="post.usr_password_confirm"
                      :class="
                        error.usr_password_confirm != null
                          ? 'is-invalid form-control form-control-sm'
                          : 'form-control form-control-sm'
                      "
                    />
                    <div
                      class="invalid-feedback"
                      v-if="error.usr_password_confirm != null"
                    >
                      {{ error.usr_password_confirm.join() }}
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn-primary mr-2">Submit</button>
              <router-link class="btn btn-danger" :to="{ name: table_module }"
                >Cancel</router-link
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import email_form from "@/components/input/email";
import s_image_form from "@/components/input/s_image";

export default {
  data() {
    return {
      module: "Admin",
      table_module: "admin",
      alias_table: "usr",
      fields: {},
      post: {
        usr_role: 1,
      },
      error: {},
      options_usr_admin:[

        { name: 'Admin', value: 1 },
        { name: 'Pegawai', value: 0 },

      ]
    };
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    email_form,
    s_image_form,
  },
  mounted() {
    this.axios.get("/users/create").then((response) => {
      this.fields = response.data.data;
    });
  },
  methods: {
    save: function () {
      this.axios
        .post("/users/register", this.post)
        .then((response) => {
          if (response.data.status != "") {
            this.$toast("Simpan data berhasil");
            this.$router.push({ name: this.table_module });
          }
        })
        .catch((error) => {
          this.disabled = false;
          if (error.response.data.error != undefined) {
            this.error = error.response.data.error;
          } else {
            this.error = error.response.data;
          }
        });
    },
    bindingData: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post, value["name"]);
      } else {
        this.$set(this.post, value["name"], value["value"]);
      }
    },
  },
};
</script>